import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useT } from '../utils/useTranslation';
import footerAjrak from '../assets/footer_ajrak.png';
import logo from '../assets/logo.jpeg';

export default function Footer() {
  const { user } = useAuth();
  const t = useT();
  return (
    <footer>
      {/* Clean gold top border */}
      <div style={{
        height: 3,
        background: 'var(--sindhi-gold)'
      }} />

      <div style={{
        background: 'linear-gradient(to bottom, var(--sindhi-navy), #050a14)',
        color: 'white', padding: '100px 2rem 40px', position: 'relative', overflow: 'hidden'
      }}>
        {/* Single decorative Ajrak on the left side */}
        <div style={{ 
          position:'absolute', bottom: -80, left: -80, width: 500, height: 500, 
          opacity: 0.12, backgroundImage: `url(${footerAjrak})`, backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat', zIndex: 0, transform: 'rotate(10deg)'
        }} />
        <div style={{ maxWidth: 1200, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(250px,1fr))', gap: 64, position: 'relative', zIndex: 1 }}>

          {/* Brand - Now on the left */}
          <div style={{ gridColumn: 'span 1.5' }}>
            <div style={{ marginBottom: 24 }}>
              <img src={logo} alt="SAS Sindh Logo" style={{ width: 72, height: 72, borderRadius: 18, objectFit: 'cover', border: '3px solid var(--sindhi-gold)' }} />
            </div>
            <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.6)', lineHeight: 1.8, maxWidth: 350 }}>
              {t('dedicatedTo')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{ fontFamily: 'var(--font-display)', fontSize: 16, fontWeight: 800, marginBottom: 24, color: 'var(--sindhi-gold)', textTransform: 'uppercase', letterSpacing: 1 }}>{t('quickLinks')}</h4>
            {[
              ['/', t('home')],
              ['/about', t('aboutUs')],
              ['/branches', t('branches')],
              ['/books', t('booksJournals')],
              ['/board', t('boardMembers')],
              ['/events', t('eventsNews')]
            ].map(([to, label]) => (
              <Link key={to} to={to} style={{ display: 'block', color: 'rgba(255,255,255,0.6)', fontSize: 14, textDecoration: 'none', marginBottom: 12, transition: 'all 0.2s' }}
                onMouseEnter={e => { e.target.style.color = 'var(--sindhi-gold)'; e.target.style.transform = 'translateX(5px)'; }}
                onMouseLeave={e => { e.target.style.color = 'rgba(255,255,255,0.6)'; e.target.style.transform = 'translateX(0)'; }}>
                {label}
              </Link>
            ))}
          </div>

          {/* Policies */}
          <div>
            <h4 style={{ fontFamily: 'var(--font-display)', fontSize: 16, fontWeight: 800, marginBottom: 24, color: 'var(--sindhi-gold)', textTransform: 'uppercase', letterSpacing: 1 }}>{t('organization')}</h4>
            {[
              ['/ohdedaan', t('officeBearers')],
              ['/qanoon', t('qanoon')],
              ...(user ? [] : [['/register', t('joinAsMember')]]),
              ['/contact', t('contactUs')],
              ['/login', t('adminLogin')]
            ].map(([to, label]) => (
              <Link key={to} to={to} style={{ display: 'block', color: 'rgba(255,255,255,0.6)', fontSize: 14, textDecoration: 'none', marginBottom: 12, transition: 'all 0.2s' }}
                onMouseEnter={e => { e.target.style.color = 'var(--sindhi-gold)'; e.target.style.transform = 'translateX(5px)'; }}
                onMouseLeave={e => { e.target.style.color = 'rgba(255,255,255,0.6)'; e.target.style.transform = 'translateX(0)'; }}>
                {label}
              </Link>
            ))}
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ fontFamily: 'var(--font-display)', fontSize: 16, fontWeight: 800, marginBottom: 24, color: 'var(--sindhi-gold)', textTransform: 'uppercase', letterSpacing: 1 }}>{t('contact')}</h4>
            <div style={{ fontSize: 15, color: 'rgba(255,255,255,0.6)', lineHeight: 2 }}>
              <div style={{ display: 'flex', gap: 10 }}><span>📍</span> Karachi, Sindh, Pakistan</div>
              <div style={{ display: 'flex', gap: 10 }}><span>📞</span> +92-XXX-XXXXXXX</div>
              <div style={{ display: 'flex', gap: 10 }}><span>✉️</span> info@sindhiadabisangat.com</div>
            </div>
          </div>
        </div>
        {/* Bottom */}
        <div style={{ maxWidth: 1200, margin: '80px auto 0', paddingTop: 40, borderTop: '1px solid rgba(255,255,255,0.1)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 20 }}>
          <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.3)', fontWeight: 500, fontFamily: 'var(--font-sindhi)' }}>
            © 2026 سنڌي ادبي سنگت سنڌ · <span style={{ fontFamily: 'var(--font-display)', fontSize: 11, verticalAlign: 'middle' }}>{t('rightsReserved')}</span>
          </p>
          <div style={{ display: 'flex', gap: 24 }}>
            {['Facebook', 'Twitter', 'YouTube', 'Instagram'].map(social => (
              <a key={social} href="#" style={{ color: 'rgba(255,255,255,0.3)', fontSize: 13, textDecoration: 'none', transition: 'color 0.2s' }}
                onMouseEnter={e => e.target.style.color = 'var(--sindhi-gold)'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.3)'}>
                {social}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
